import PoiMap from 'components/maps/PoiMap';
import SearchContext from 'contexts/SearchContext';
import { buildApiQuery } from 'contexts/SearchHelpers';
import React, { useContext, useEffect } from 'react';
import useSWR from 'swr';
import { setMapResults } from 'contexts/SearchActions';
import { AreaTypeKey } from 'models/Area';

function SearchMap() {
    const context = useContext(SearchContext);
    const { state, dispatch } = context;
    const { area, category, filters } = state;

    const apiQuery = buildApiQuery({
        area,
        category,
        filters,
        mapView: true
    });

    const { data: mapPois, isValidating: isFetchingData } = useSWR(`/public/map-query?${apiQuery}`);

    let viewportPreset = null;
    if (area?.centroid) {
        viewportPreset = {
            latitude: area.centroid.coordinates[1],
            longitude: area.centroid.coordinates[0],
            zoom: area.type.key === AreaTypeKey.Municipality ? 11 : 9
        };
    }

    useEffect(() => {
        if (mapPois) {
            setMapResults(dispatch, mapPois.data);
        }
    }, [mapPois]);

    return (
        <div className="w-full h-full min-h-[500px] mt-4 relative">
            <PoiMap pois={state.mapResults} isLoading={isFetchingData} viewportPreset={viewportPreset} />
        </div>
    );
}

export default SearchMap;
